import type { IEmailInputProps } from "../../types";
import { TextField } from "@mui/material";

export default function EmailInput(props: IEmailInputProps) {
  const { label, helperText, email, error, styles, handleEmailChange } = props;

  return (
    <TextField
      fullWidth
      required
      label={label}
      name="email"
      id="email_field"
      size="medium"
      value={email ? email : ""}
      onChange={handleEmailChange}
      error={error && !!email}
      helperText={helperText}
      sx={styles.space}
    />
  );
}
